import { render } from "./ManageGroups.vue?vue&type=template&id=bbc64f72"
import script from "./ManageGroups.vue?vue&type=script&lang=js"
export * from "./ManageGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__